
export enum ProductTypeOPEEnum {
  GetAllProductTypes = 'getAllProductTypes',
  GetProductTypes = 'getProductTypes',
  PutProductType = 'putProductType',
  DelProductType = 'delProductType'
}
